/**
 * API-хелпер с credentials (cookies) и CSRF для Django session auth.
 * Прокси CRA перенаправляет /api на localhost:8000 — one origin, cookies работают.
 */
const API_BASE = '/api';

let _csrfToken = null;

export async function getCsrfToken() {
  if (_csrfToken) return _csrfToken;
  const res = await fetch(`${API_BASE}/auth/csrf/`, { credentials: 'include' });
  const data = await res.json();
  _csrfToken = data.csrfToken;
  return _csrfToken;
}

export function apiFetch(url, options = {}) {
  const opts = {
    credentials: 'include',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  };
  const method = (options.method || 'GET').toUpperCase();
  if (method !== 'GET' && method !== 'HEAD') {
    return getCsrfToken().then((token) => {
      opts.headers['X-CSRFToken'] = token;
      return fetch(url, opts);
    });
  }
  return fetch(url, opts);
}

export function clearCsrfToken() {
  _csrfToken = null;
}

export { API_BASE };
